const SectionThumbCarouselDefaults = {
  "slides": [
    {
      "heading": "Robust reliability",
      "copy": "With 99.9% network reliability, Frontier Fiber will keep you connected to customers, vendors and critical business applications.",
      "image": {
        "src": "/img/page-one/ThumbCarousel-2.jpg",
        "alt": "Image Description"
      }
    },
    {
      "heading": "Maximum coverage",
      "copy": "Virtually eliminate dead spots with an ultra-fast Next-Gen Wi-Fi 6E router, included in your plan.",
      "image": {
        "src": "/img/page-one/ThumbCarousel-3.jpg",
        "alt": "Image Description"
      }
    },
    {
      "heading": "White glove installation",
      "copy": "Let us handle the hassle. Our professionals will call in advance to make sure you have everything you need to get set up.",
      "image": {
        "src": "/img/page-one/ThumbCarousel-4.jpg",
        "alt": "Image Description"
      }
    }
  ]
}

export default SectionThumbCarouselDefaults;
